import React, { Component } from 'react';
import PropTypes from 'prop-types';
import hints from '../data/hints.json'; // Ensure this path matches the actual file location
import './hint-widget.css'

class HintWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      htmlContent: '<p>Loading...</p>',
    };
  }

  componentDidMount() {
    this.fetchHint();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.guideUrl !== this.props.guideUrl) {
      this.fetchHint();
    }
  }

  fetchHint() {
    const { guideUrl } = this.props;
    const foundHint = hints.find(hint => hint.slug === guideUrl);
    this.setState({
      htmlContent: foundHint ? foundHint.html : '<p>No hint available</p>',
    });
  }

  render() {
    const { htmlContent } = this.state;

    return (
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    );
  }
}

HintWidget.propTypes = {
  guideUrl: PropTypes.string.isRequired,
};

export default HintWidget;


// WEBPACK FOOTER //
// ./src/templates/Challenges/components/HintWidget.js